Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();exports.default=






bindKeyboard;var _react=require('react');var _react2=_interopRequireDefault(_react);var _keycode=require('keycode');var _keycode2=_interopRequireDefault(_keycode);var _reactEventListener=require('react-event-listener');var _reactEventListener2=_interopRequireDefault(_reactEventListener);var _reactSwipeableViewsCore=require('react-swipeable-views-core');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function bindKeyboard(MyComponent){var
BindKeyboard=function(_Component){_inherits(BindKeyboard,_Component);function BindKeyboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BindKeyboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BindKeyboard.__proto__||Object.getPrototypeOf(BindKeyboard)).call.apply(_ref,[this].concat(args))),_this),_this.























state={},_this.



















handleKeyDown=function(event){
var action=void 0;var _this$props=





_this.props,_this$props$axis=_this$props.axis,axis=_this$props$axis===undefined?'x':_this$props$axis,children=_this$props.children,onChangeIndex=_this$props.onChangeIndex,slideCount=_this$props.slideCount;

switch((0,_keycode2.default)(event)){
case'page down':
case'down':
if(axis==='y'){
action='decrease';
}else if(axis==='y-reverse'){
action='increase';
}
break;

case'left':
if(axis==='x'){
action='decrease';
}else if(axis==='x-reverse'){
action='increase';
}
break;

case'page up':
case'up':
if(axis==='y'){
action='increase';
}else if(axis==='y-reverse'){
action='decrease';
}
break;

case'right':
if(axis==='x'){
action='increase';
}else if(axis==='x-reverse'){
action='decrease';
}
break;

default:
break;}


if(action){
var indexLatest=_this.state.index;
var indexNew=indexLatest;

if(action==='increase'){
indexNew+=1;
}else{
indexNew-=1;
}

if(slideCount||children){
indexNew=(0,_reactSwipeableViewsCore.mod)(indexNew,slideCount||_react.Children.count(children));
}


if(_this.props.index===undefined){
_this.setState({
index:indexNew});

}

if(onChangeIndex){
onChangeIndex(indexNew,indexLatest);
}
}
},_this.

handleChangeIndex=function(index,indexLatest){

if(_this.props.index===undefined){
_this.setState({
index:index});

}

if(_this.props.onChangeIndex){
_this.props.onChangeIndex(index,indexLatest);
}
},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BindKeyboard,[{key:'componentWillMount',value:function componentWillMount(){this.setState({index:this.props.index||0});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var index=nextProps.index;if(typeof index==='number'&&index!==this.props.index){this.setState({index:index});}}},{key:'render',value:function render()

{var _props=




this.props,indexProp=_props.index,onChangeIndex=_props.onChangeIndex,other=_objectWithoutProperties(_props,['index','onChangeIndex']);var


index=
this.state.index;

return(
_react2.default.createElement(_reactEventListener2.default,{target:'window',onKeyDown:this.handleKeyDown},
_react2.default.createElement(MyComponent,_extends({
index:index,
onChangeIndex:this.handleChangeIndex},
other))));



}}]);return BindKeyboard;}(_react.Component);BindKeyboard.propTypes={axis:_react.PropTypes.oneOf(['x','x-reverse','y','y-reverse']),children:_react.PropTypes.node,index:_react.PropTypes.number,onChangeIndex:_react.PropTypes.func,slideCount:_react.PropTypes.number};


return BindKeyboard;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-utils/lib/bindKeyboard.js
// module id = 730
// module chunks = 0